import { useQuery } from '@tanstack/react-query'
import { apiInstance } from 'services/api'
import { useMasquaradeToken } from 'services/masquarade/masquarade.hooks'
import { useAccessToken } from 'services/token/token.hooks'
import type { LeaseContractResponse } from 'services/contracts/hooks/useLeaseContracts'

export interface LeaseContractsDepositAccountBalanceResponse {
  id: number
  depositBalanceValue: string
}

export const useLeaseContractsDepositAccountBalance = (id?: LeaseContractResponse['id']) => {
  const { accessToken } = useAccessToken()
  const { masquaradeToken } = useMasquaradeToken()

  const {
    data: leaseContractsDepositAccountBalance = {
      depositBalanceValue: ''
    },
    ...rest
  } = useQuery({
    queryKey: ['leaseContractsDepositAccountBalance', id, masquaradeToken],
    queryFn: () =>
      apiInstance<LeaseContractsDepositAccountBalanceResponse>({
        url: `/lease/contracts/${id}/deposit-account-balance/`,
        method: 'GET',
        headers: {
          authorization: `Bearer ${accessToken}`,
          'mask-authorization': !!masquaradeToken ? `Token ${masquaradeToken}` : undefined
        }
      }).then(({ data }) => data),
    enabled: !!accessToken && !!id
  })

  return { leaseContractsDepositAccountBalance, ...rest }
}
